// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1oeqqdw0 {
  position: relative;
}
._1oeqqdw0::after {
  content: "";
  position: absolute;
  display: none;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 50%;
  background: white;
  transform: translateX(-50%);
}
._1oeqqdw2 {
  width: 100%;
}
@media screen and (min-width: 768px) {
  ._1oeqqdw0::after {
    display: block;
  }
  ._1oeqqdw1 {
    flex-basis: calc(33% - 8px);
  }
  ._1oeqqdw2 {
    max-width: 160px;
  }
}
@media print {
  ._1oeqqdw1 {
    border: 1px solid black;
  }
  ._1oeqqdw3 {
    display: none;
  }
  ._1oeqqdw4 {
    border: 1px solid black;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["._1oeqqdw0 {\n  position: relative;\n}\n._1oeqqdw0::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  width: 100vw;\n  height: 100%;\n  top: 0;\n  left: 50%;\n  background: white;\n  transform: translateX(-50%);\n}\n._1oeqqdw2 {\n  width: 100%;\n}\n@media screen and (min-width: 768px) {\n  ._1oeqqdw0::after {\n    display: block;\n  }\n  ._1oeqqdw1 {\n    flex-basis: calc(33% - 8px);\n  }\n  ._1oeqqdw2 {\n    max-width: 160px;\n  }\n}\n@media print {\n  ._1oeqqdw1 {\n    border: 1px solid black;\n  }\n  ._1oeqqdw3 {\n    display: none;\n  }\n  ._1oeqqdw4 {\n    border: 1px solid black;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
